import { Trans } from '@lingui/react/macro'
import { Badge } from 'designSystem/components/Badge'
import { Button } from 'designSystem/components/Button'
import { Spinner } from 'designSystem/components/Spinner'
import React, { useCallback } from 'react'

export const PhotoHeroAction: React.FC<{
  photoId: string
  isHero: boolean
  saving: boolean
  disabled: boolean
  onMakeHero: (photoId: string) => void
}> = ({ photoId, isHero, saving, disabled, onMakeHero }) => {
  const makeHero = useCallback(() => onMakeHero(photoId), [onMakeHero, photoId])

  return isHero ? (
    <Badge variant='success'>
      <Trans>Hero</Trans>
    </Badge>
  ) : (
    <Button
      type='button'
      variant='outline'
      disabled={disabled}
      onClick={makeHero}>
      {saving && <Spinner data-icon='inline-start' />}
      <Trans>Make hero</Trans>
    </Button>
  )
}
